export class ReTree {
  test(str, regex) {
    if (typeof regex === 'string') {
      regex = new RegExp(regex);
    }
    if (regex instanceof RegExp) {
      return regex.test(str);
    } else if (regex && Array.isArray(regex.and)) {
      return regex.and.every((item) => {
        return this.test(str, item);
      });
    } else if (regex && Array.isArray(regex.or)) {
      return regex.or.some((item) => {
        return this.test(str, item);
      });
    } else if (regex && regex.not) {
      return !this.test(str, regex.not);
    } else {
      return false;
    }
  }
  exec(str, regex) {
    if (typeof regex === 'string') {
      regex = new RegExp(regex);
    }
    if (regex instanceof RegExp) {
      return regex.exec(str);
    } else if (regex && Array.isArray(regex)) {
      return regex.reduce((res, item) => {
        return !!res ? res : this.exec(str, item);
      }, null);
    } else {
      return null;
    }
  }
}
